// extracted by mini-css-extract-plugin
export var lbContainerOuter = "B_t9";
export var lbContainerInner = "B_vb";
export var movingForwards = "B_vc";
export var movingForwardsOther = "B_vd";
export var movingBackwards = "B_vf";
export var movingBackwardsOther = "B_vg";
export var lbImage = "B_vh";
export var lbOtherImage = "B_vj";
export var prevButton = "B_vk";
export var nextButton = "B_vl";
export var closing = "B_vm";
export var appear = "B_vn";